/**
 * This methods selects Elements from a specific context by a selector
 * @param {string} selector Selector of the element to find
 * @param {Element|HTMLDocument} [element] Context of the selectable
 * @returns {Array<Element>} Am array with selected Elements
 */
export default (
  selector: string,
  element: Element | Document = window.document
) => [].slice.call(element.querySelectorAll(selector));
